import { Component, ElementRef, HostBinding } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector, WizDatasource } from '@wizeoo/akm-component-lib';
import { Observable } from 'rxjs';
import { AttachmentService } from '../../../../command/core/attachment/attachment.service';

export type ThumbData = { 
  blobId: string,
  obs: Observable<string>,
  order?: number,
  provider?:WizDatasource<ThumbData>
};



@Component({
  selector: 'thumb-renderer',
  templateUrl: './thumb.renderer.html'
})
export class ThumbRenderer implements IWizItemRenderer<null, ThumbData> {
  @HostBinding('style.width') width: string = '100%';
  @HostBinding('style.height') height: string = '100%';
  
  
  constructor(public elementRef: ElementRef) {}

  /** les clés de la vision */
  public thumbDS: WizDatasource<ThumbData> = new WizDatasource<ThumbData>().build();
  // pas de sort, sinon prb de drag'n'drop (plus possible d'ordonner) .setSortFields([{ property: 'order', way: 'asc', numeric: true }])

  public get item(): ThumbData {
    return this.data;
  }

  public getBlobObs(k:string): Observable<string> {
    return AttachmentService.getInstance().downloadAttachmentForWidget(k, true);
  }

  data: any;
  owner: WizBaseCollector;

  public mayUp(): boolean {
    return this.item.provider.getItemIndex(this.item) > 0;
  }

  public mayDown(): boolean {
    return this.item.provider.getItemIndex(this.item) < this.item.provider.length -1;
  }

  public doUp(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.item.order--;
    this.item.provider.getSource().forEach(t => {
      if(t.order === this.item.order && t !== this.item) {
        t.order++;
      }
    });
    this.item.provider.refresh(); 
    // console.log('refresh provider up');
  }

  public doDown(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.item.order++;
    this.item.provider.getSource().forEach(t => {
      if(t.order === this.item.order && t !== this.item) {
        t.order--;
      }
    });
    this.item.provider.refresh(); 
    // console.log('refresh provider down');
  }

}
